function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { getKeys } from '@bydesign-ui/utils';
import { ScheduleSelectType, formatTime } from './SchedulePanel';
export var Schedule = function (_Emitter) {
  _inherits(Schedule, _Emitter);

  var _super = _createSuper(Schedule);

  function Schedule() {
    var _this;

    _classCallCheck(this, Schedule);

    _this = _super.apply(this, arguments);
    _this.value = [];
    _this.datasource = [];
    _this.divider = 1;
    _this.interrupted = true;
    _this.inverseSelect = true;
    _this.disabled = false;
    _this.valueHash = {};
    return _this;
  }

  _createClass(Schedule, [{
    key: "updateValue",
    value: function updateValue(value) {
      var _this2 = this;

      if (this.value === value || this.value.length === 0 && value.length === 0) {
        return;
      }

      this.value = value;
      this.valueHash = {};
      this.value.forEach(function (val) {
        return _this2.valueHash[val.label] = val.value;
      });
      this.emit('repaint-panel');
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var datasource = options.datasource,
          _options$interrupted = options.interrupted,
          interrupted = _options$interrupted === void 0 ? true : _options$interrupted,
          _options$divider = options.divider,
          divider = _options$divider === void 0 ? 1 : _options$divider,
          isTimeDisabled = options.isTimeDisabled,
          _options$inverseSelec = options.inverseSelect,
          inverseSelect = _options$inverseSelec === void 0 ? true : _options$inverseSelec,
          _options$disabled = options.disabled,
          disabled = _options$disabled === void 0 ? false : _options$disabled;
      this.interrupted = interrupted;
      this.divider = divider;
      this.inverseSelect = inverseSelect;
      this.disabled = disabled;

      if (this.datasource !== datasource) {
        this.emit('datasource-update');
        this.datasource = datasource;
      }

      if (isTimeDisabled != null) {
        this.isTimeDisabled = isTimeDisabled;
      }
    }
  }, {
    key: "getDatasource",
    value: function getDatasource() {
      return this.datasource;
    }
  }, {
    key: "getDivider",
    value: function getDivider() {
      return this.divider;
    }
  }, {
    key: "getInterrupted",
    value: function getInterrupted() {
      return this.interrupted;
    }
  }, {
    key: "getDisabled",
    value: function getDisabled() {
      return this.disabled;
    }
  }, {
    key: "getItemSelectType",
    value: function getItemSelectType(label, index) {
      var selected = false;
      var selectType = ScheduleSelectType.NONE;
      var value = this.value;
      value.some(function (item) {
        if (item.label === label) {
          if (item.value.indexOf(index) >= 0) {
            selected = true;
          }

          return true;
        }
      });

      if (selected) {
        selectType = ScheduleSelectType.SELECTED;
      }

      return selectType;
    }
  }, {
    key: "isTimeDisabled",
    value: function isTimeDisabled(lable, index) {
      return false;
    }
  }, {
    key: "setValue",
    value: function setValue(addVal) {
      var _this3 = this;

      var value = [];
      var flag = true;

      if (this.disabled) {
        return;
      }

      var newValueHash = {};
      addVal.forEach(function (val) {
        newValueHash[val.label] = val.value;
      });
      this.datasource.some(function (data) {
        var val = _this3.valueHash[data] || [];
        var newVal = newValueHash[data] || [];
        var res = [].concat(val, newVal).sort();

        if (res.some(function (idx) {
          return _this3.isTimeDisabled(data, idx);
        })) {
          flag = false;
          return true;
        }

        if (_this3.interrupted) {
          res = _this3.calcInterrupted(res);
        } else {
          res = _this3.calcUninterrupted(res, val) || newVal;
        }

        value.push({
          label: data,
          value: res
        });
      });

      if (flag) {
        this.emit('value-change', value);
      } else {
        this.emit('repaint-panel');
      }
    }
  }, {
    key: "clearValue",
    value: function clearValue() {
      if (this.disabled) {
        return;
      }

      this.emit('value-change', []);
    }
  }, {
    key: "getDisplayInfo",
    value: function getDisplayInfo() {
      var _this4 = this;

      var info = [];
      var colTime = 60 / this.divider;
      this.value.forEach(function (item) {
        var label = item.label,
            value = item.value;

        var values = _this4.splitValue(value);

        var formatValues = [];
        values.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              startIdx = _ref2[0],
              endIdx = _ref2[1];

          var st = startIdx * colTime;
          var et = (endIdx + 1) * colTime;
          formatValues.push("".concat(formatTime(st), "~").concat(formatTime(et)));
        });
        info.push({
          label: label,
          value: formatValues
        });
      });
      return info;
    }
  }, {
    key: "splitValue",
    value: function splitValue(value) {
      var res = [];
      var len = value.length;
      var left;
      var right;
      value.forEach(function (item, i) {
        if (left == null || right == null) {
          left = right = item;
        } else {
          if (right + 1 === item) {
            right = item;
          } else {
            res.push([left, right]);
            left = right = item;
          }
        }

        if (i === len - 1) {
          res.push([left, right]);
        }
      });
      return res;
    }
  }, {
    key: "calcInterrupted",
    value: function calcInterrupted(value) {
      var hash = {};
      var inverseSelect = this.inverseSelect;
      value.forEach(function (val) {
        hash[val] = (hash[val] || 0) + 1;
      });
      return inverseSelect ? getKeys(hash).filter(function (item) {
        return hash[item] === 1;
      }).map(function (key) {
        return +key;
      }) : getKeys(hash).map(function (key) {
        return +key;
      });
    }
  }, {
    key: "calcUninterrupted",
    value: function calcUninterrupted(value, originValue) {
      var hash = {};
      var inverseSelect = this.inverseSelect;
      value.forEach(function (val) {
        hash[val] = (hash[val] || 0) + 1;
      });
      var newValues = getKeys(hash).map(function (key) {
        return +key;
      });
      var duplicate = getKeys(hash).some(function (item) {
        return hash[item] > 1;
      });

      if (this.splitValue(newValues).length > 1) {
        return false;
      }

      if (duplicate && newValues.length === originValue.length) {
        return inverseSelect ? [] : newValues;
      }

      return newValues;
    }
  }]);

  return Schedule;
}(Emitter);